<template>
  <div>
    <div class="full-header">
      <div class="full-header-wrapper">
        <p class="title">{{ Translator('soprasolar.claim_request.demand.title', { number: number }) }}</p>
        <a :href="'/api/claim-requests/' + projectApplicationToken + '/excel'" class="demand-button" target="_blank" rel="noopener noreferrer" :disabled="isLoading" v-if="isAdmin">
          {{ Translator("soprasolar.claim_request.demand.download") }}
          <i class="ic ic-save" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </a>
      </div>
    </div>
    <div class="project-wrapper">
      <resume />
      <user />
    </div>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-claim/assets/styles/import";
.full-header {
  @include fullSize;
  @include vertical-spacing-bottom(.5);
  @include vertical-spacing-inner;
  background-color: $blue-light;
  .full-header-wrapper {
    @include wrapper;
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
  .title {
    @include title(2);
    margin-bottom: 0;
  }
}
user {
  max-width: rem(250);
  flex-shrink: 0;
}
.demand-button {
  @include cta;
}
.project-wrapper {
  width: 100%;
  display: flex;
  @include mobile {
    flex-direction: column;
    gap: rem(40);
  }
  @include tablet {
    align-items: flex-start;
    justify-content: space-between;
    gap: rem(50);
  }
  .demand-button {
    margin-top: rem(30);
  }
  .project-contact {
    width: 100%;
    padding: rem(15) rem(30);
  }
}
</style>
<script>
import AppControlService from '@/soprasolar-claim/services/AppControl';
import Resume from '@/soprasolar-claim/components/Resume';
import User from '@/soprasolar-claim/components/User';

export default {
  name: 'demand',
  components: {
    Resume,
    User
  },
  data () {
    return {
      number: AppControlService.number,
      datas: AppControlService.datas,
      contacts: AppControlService.contacts,
      isLoading: false,
      solutionsPage: window.solutionsPageLink,
      projectApplicationToken: null
    }
  },

  computed: {
    isAdmin: () => {
      return AppControlService.isAdmin;
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    this.projectApplicationToken = params.get("token");
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {},

  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      this.contacts = AppControlService.contacts;
    },
  }
};
</script>